// tippi/src/pages/carrier/ServiceForm.js
import React, { useState } from 'react';
import { carrierApi } from '../../firebase/functionsService';
import Field from './Field';
import { ui } from './carrierStyles';

const EMPTY = { date: '', type: '', odometerKm: '', costNok: '', note: '', nextServiceDate: '', nextServiceKm: '' };
const isBlankOrInt = (s) => String(s).trim() === '' || /^[0-9]+$/.test(String(s).trim());
const toInt = (s) => (String(s).trim() === '' ? null : Number(s));

// Registrerer en service på en bil. Serveren oppdaterer «sist» og «neste» service på bilen.
export default function ServiceForm({ orgId, vehicleId }) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    const found = {};
    if (!/^\d{4}-\d{2}-\d{2}$/.test(form.date)) found.date = 'Velg dato';
    if (!form.type.trim()) found.type = 'Skriv inn type service';
    if (!isBlankOrInt(form.odometerKm)) found.odometerKm = 'Skriv et helt tall';
    if (!isBlankOrInt(form.costNok)) found.costNok = 'Skriv et helt tall';
    if (!isBlankOrInt(form.nextServiceKm)) found.nextServiceKm = 'Skriv et helt tall';
    setErrors(found);
    if (Object.keys(found).length > 0) return;
    setStatus('saving');
    setMessage('');
    try {
      await carrierApi.addVehicleService({
        orgId, vehicleId,
        input: {
          date: form.date, type: form.type, odometerKm: toInt(form.odometerKm), costNok: toInt(form.costNok),
          note: form.note, nextServiceDate: form.nextServiceDate || null, nextServiceKm: toInt(form.nextServiceKm),
        },
      });
      setForm(EMPTY);
      setStatus('idle');
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Kunne ikke lagre servicen');
    }
  }

  return (
    <form onSubmit={submit} noValidate>
      <div style={ui.row}>
        <Field id="s-date" label="Dato" error={errors.date} style={{ flex: 1, minWidth: 140 }}>
          <input id="s-date" type="date" style={ui.input} value={form.date} onChange={set('date')} />
        </Field>
        <Field id="s-type" label="Type service" error={errors.type} style={{ flex: 2, minWidth: 180 }}>
          <input id="s-type" style={ui.input} value={form.type} onChange={set('type')} maxLength={60} />
        </Field>
      </div>
      <div style={ui.row}>
        <Field id="s-km" label="Km-stand" error={errors.odometerKm} style={{ flex: 1, minWidth: 140 }}>
          <input id="s-km" style={ui.input} value={form.odometerKm} onChange={set('odometerKm')} inputMode="numeric" />
        </Field>
        <Field id="s-cost" label="Kostnad (kr)" error={errors.costNok} style={{ flex: 1, minWidth: 140 }}>
          <input id="s-cost" style={ui.input} value={form.costNok} onChange={set('costNok')} inputMode="numeric" />
        </Field>
      </div>
      <Field id="s-note" label="Notat">
        <input id="s-note" style={ui.input} value={form.note} onChange={set('note')} maxLength={500} />
      </Field>
      <div style={ui.row}>
        <Field id="s-next-date" label="Neste service (dato)" style={{ flex: 1, minWidth: 140 }}>
          <input id="s-next-date" type="date" style={ui.input} value={form.nextServiceDate} onChange={set('nextServiceDate')} />
        </Field>
        <Field id="s-next-km" label="Neste service (km)" error={errors.nextServiceKm} style={{ flex: 1, minWidth: 140 }}>
          <input id="s-next-km" style={ui.input} value={form.nextServiceKm} onChange={set('nextServiceKm')} inputMode="numeric" />
        </Field>
      </div>
      {status === 'error' && <p role="alert" style={ui.error}>{message}</p>}
      <button type="submit" className="tippi-btn" style={{ ...ui.btn, marginTop: 14 }} disabled={status === 'saving'}>
        {status === 'saving' ? 'Lagrer…' : 'Legg til service'}
      </button>
    </form>
  );
}
